// extracted by mini-css-extract-plugin
module.exports = {"container":"Split_container__1a0Xe","body":"Split_body__LMMXv","playlistBoxes":"Split_playlistBoxes__1K9dA","bottomBar":"Split_bottomBar__2DwRz"};